import { createIcon } from "@chakra-ui/icons";

// Created from logout.svg

export const LogoutIcon = createIcon({
  displayName: "Signout",
  viewBox: "0 0 24 24",
  path: (
    <g fill="none">
      <path
        id="Vector"
        d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path id="Vector_2" d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="1.5" />
      <path
        id="Vector_3"
        d="M21 12H9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </g>
  ),
});
